import React from 'react';
import { Alert } from 'react-bootstrap';
import { EMPTY_COUNT, EMPTY_STRING } from '../../utils/constants';

const SuccessAlert = (props) => {

    const RenderMessages = (
        props.success.map((message) => message + "\n")
    )

    return  EMPTY_COUNT < props.success.length && <Alert bsStyle="success" className={props.wrap ? EMPTY_STRING : "pre-wrap"}>{RenderMessages}</Alert>
};

export default SuccessAlert;